const API_URL =
  process.env.REACT_APP_API_URL ||
  "https://b10wjf1l891nnjplstyphkc5.schoolportalhub.com";

export const tracking = async (inquiryNumber) => {
  try {
    const resp = await fetch(`${API_URL}/api/track/${inquiryNumber}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await resp.json();

    if (!resp.ok) {
      // Return error in the format your component expects
      return {
        response: {
          response: {
            errors: [
              {
                message: data.error || "Failed to track package",
              },
            ],
          },
        },
      };
    }

    // Return data in the format your component expects
    return {
      response: data,
    };
  } catch (error) {
    // Return network error in expected format
    return {
      response: {
        response: {
          errors: [
            {
              message:
                error.message || "Network error. Please check your connection.",
            },
          ],
        },
      },
    };
  }
};
